import { atom } from 'recoil';
import type { ONSAIdentifier, OnsaStep } from '../types/onsaTypes';

const getOnsaStep = (): OnsaStep => {
    const searchParams = new URLSearchParams(window.location.search);
    const getParamValue = (param: string): string => searchParams.get(param) ?? '';
    const onsaStep = getParamValue('onsastep');
    if (onsaStep === 'CoveragePackagePage') {
        return 'CoveragePackagePage';
    } else if (onsaStep === 'ShoppingBasketPage') {
        return 'ShoppingBasketPage';
    } else if (onsaStep) {
        return 'ProductSelectorPage';
    }
    return undefined;
};

export const onsaInfoAtom = atom<ONSAIdentifier>({
    key: 'onsaInfo',
    default: ((): ONSAIdentifier => {
        const flavourName =
            new URLSearchParams(window.location.search).get('forsikringsnavn') ?? undefined;
        return {
            onsaStep: getOnsaStep(),
            flavourName
        };
    })()
});
